import * as React from 'react';
import { Modal } from '../../../../../Modal';
import { TaxDeduction } from "../../../../../TaxDeduction";
import * as main from '../../../styles/mainOld.module.scss';
import * as personality from './personality.module.scss';

export const Personality = ({ widget, buttonText, showButton }) => {
  const [showModal, setShowModal] = React.useState(false);

  return (
    <section className={personality.personality}>
      <div className="container">
        <h2 className={`${personality.personality__title} ${main.mainTitle}`}>Это мешает ребенку расти как личность</h2>
        <div className={`row ${personality.personality__row}`}>
          <div className={`col-12 col-md-6 ${personality.personality__col} ${personality.personality__colFirst}`}>
            <h3 className={personality.personality__subtitle}>Cамооценка и&nbsp;уверенность в&nbsp;себе снижаются</h3>
            <p className={personality.personality__text}>
              Низкие оценки и&nbsp;недовольные учителя как бы говорят: «Ты не&nbsp;сможешь». Ребенок начинает
              сомневаться в&nbsp;себе, становится нерешительным. Неуверенность порождает всё новые неудачи, которые,
              в&nbsp;свою очередь, мешают стать увереннее.
            </p>
          </div>
          <div
            className={`col-12 col-md-6 ${personality.personality__col} ${personality.personality__colImg} ${personality.personality__colSecond}`}
          ></div>
          <div
            className={`col-12 col-md-6 ${personality.personality__col} ${personality.personality__colImg} ${personality.personality__colThird}`}
          ></div>
          <div className={`col-12 col-md-6 ${personality.personality__col} ${personality.personality__colFourth}`}>
            <h3 className={personality.personality__subtitle}>Появляется стойкое отвращение к&nbsp;любому обучению</h3>
            <p className={personality.personality__text}>
              Учеба ассоциируется с&nbsp;тяжелейшим трудом. Часто такие дети, повзрослев, готовы десятилетиями работать
              на&nbsp;рутинной бесперспективной должности, лишь бы больше никогда не&nbsp;учиться.
            </p>
          </div>
          <div className={`col-12 col-md-6 ${personality.personality__col} ${personality.personality__colFifth}`}>
            <h3 className={personality.personality__subtitle}>Начинаются проблемы с&nbsp;ответственностью</h3>
            <p className={personality.personality__text}>
              Выполняя обязательства из-под палки, ребенок рано или поздно придет к&nbsp;выводу, что быть
              ответственным&nbsp;— тяжело и&nbsp;неприятно. Так безответственность перерастёт в&nbsp;бунтарство.
            </p>
          </div>
          <div
            className={`col-12 col-md-6 ${personality.personality__col} ${personality.personality__colImg} ${personality.personality__colSixth}`}
          ></div>
        </div>
        {
          showButton ?
          <>
            <button
              className={`${main.btn} ${personality.personality__link}`}
              onClick={() => {
                setShowModal(true);
              }}
            >
              {buttonText}
            </button>
            <TaxDeduction margin={"30px 0 0"} align={"center"}/>
          </>
          : null
        }
      </div>

      <Modal
        open={showModal}
        onClose={() => {
          setShowModal(false);
        }}
      >
        {widget}
      </Modal>
    </section>
  );
};
